import * as React from "react";
import style from "./Office.module.css";
import chairs from "../../Assets/chairs.png";
import people from "../../Assets/people.png";
import table from "../../Assets/table.png";
import Button from "@mui/material/Button";

export const Office = () => {
  return (
    <div className={style.office} id="servicios">
      <div className={style.item1}>
        <div className={style.colors}>
          <div className={style.color1}></div>
          <div className={style.color2}></div>
          <div className={style.color3}></div>
        </div>
        <div>
          <img src={table} alt="" className={style.img1} />
        </div>
        <div>
          <img src={people} alt="" className={style.img2} />
        </div>
      </div>

      <div className={style.item2}>
        <h3 className={style.title2}>
          {" "}
          Tu oficina y equipo <a className={style.textAmarillo}> legal </a> en un mismo lugar.
        </h3>
        <div className={style.content}>
          <img className={style.imgFloat} src={chairs} alt="" />

          <div className={style.textCont}>
            <p className={style.text}>
              Somos un espacio que combina coworking con asesoría legal dandote
              un espacio ideal para que desarrolles tu negocio de la mano de un
              equipo legal experto en el área.
            </p>
            <ul className={style.list}>
              <li>
                Expertos en tu sector: Contamos con asesores para guiarte en el
                aréa empresarial.
              </li>
              <li>
                Espacios para trabajar, eventos, reuniones y todas tus
                necesidades.
              </li>
              <li>Ubicación cercana y accesible.</li>
            </ul>{" "}
            <a href="#planes" style={{textDecoration:"none"}}>
              <Button variant="contained" color="primary" className={style.btn}>
                Ver planes
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
